import React, { useState, useEffect } from "react"
import * as R from 'ramda'

import { Form, Input, Button } from 'antd'

export function PartyLogin(props) {
    const { getFieldDecorator } = props.form
    const { handleLogin, end } = props

    const [idInput, setIdInput] = useState(false)
    const [phoneInput, setPhoneInput] = useState(false)
    const [btnClickable, setBtnClickable] = useState(false)

    useEffect(() => {
        setBtnClickable(R.and(idInput, phoneInput))
    }, [idInput, phoneInput])

    const handleIdChange = (event) => {
        setIdInput(!R.isEmpty(event.target.value))
    }

    const handlePhoneChange = (event) => {
        setPhoneInput(!R.isEmpty(event.target.value))
    }

    const handleOnFinish = (event) => {
        event.preventDefault()
        props.form.validateFields((err, values) => {
            if (!err) {
                handleLogin(values)
            }
        })
    }

    return (
        <div className="party-login-form">
            <Form
                onSubmit={handleOnFinish}
            >
                <Form.Item>
                    {getFieldDecorator('id', {
                        rules: [{
                            required: true,
                            pattern: new RegExp('^[A-Z]{1}[0-9]{9}$'),
                            message: '請輸入正確的身分證'
                        }],
                        validateTrigger: 'onSubmit',
                    })(
                        <Input
                            placeholder="身分證字號"
                            onChange={(event) => handleIdChange(event)}
                        />,
                    )}
                </Form.Item>

                <Form.Item>
                    {getFieldDecorator('phone', {
                        rules: [{
                            required: true,
                            message: '請輸入手機號碼'
                        }],
                        validateTrigger: 'onSubmit',
                    })(
                        <Input
                            placeholder="手機號碼"
                            onChange={(event) => handlePhoneChange(event)}
                        />,
                    )}
                </Form.Item>

                <Form.Item>
                    <Button
                        htmlType="submit"
                        className={!end ? "party-login-form-btn" : "web-hidden"}
                        disabled={R.not(btnClickable)}
                    >
                        登入
                    </Button>

                    <Button
                        className={end ? "party-login-form-btn" : "web-hidden"}
                        disabled
                    >
                        已無法報名
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default Form.create()(PartyLogin)